import React, { useEffect, useState } from "react";

const FeedGroupManagementItem = ({ item, users }) => {
  const [usersString, setUsersString] = useState("");

  useEffect(() => {
    const post = item?.post;
    const userIds = post?.user_ids;

    if (!post || !Array.isArray(userIds) || userIds.length === 0 || !users) {
      setUsersString("");
      return;
    }

    const names = userIds
      .map((id) => {
        const user = users[id];
        if (!user) return null;
        return `${user.first_name ?? ""} ${user.last_name ?? ""}`.trim();
      })
      .filter(Boolean);

    setUsersString(names.join(", "));
  }, [item, users]);

  if (!usersString) return null;

  return (
    <div className="feed-group-management-item-container">
      <div className="feed-group-management-side-line" />
      <div className="feed-group-management-text">
        {usersString} has joined the group
      </div>
      <div className="feed-group-management-side-line" />
    </div>
  );
};

export default FeedGroupManagementItem;
